var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-panel-item",class:{ 'legend-panel-item--active': _vm.isActiveStatus },on:{"click":_vm.onClickLegendPanelItem}},[_c('button',{staticClass:"legend-panel-item__btn",style:({
            'background': _vm.colorBox,
            'borderColor': _vm.borderColor,
        })}),_c('p',{staticClass:"legend-panel-item__title"},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }